import yup from "@utils/validation/yup-extended";

export const CustomSSLSettingsSchema = yup.object().shape({
  pem_certificate: yup.string().trim().required(),
});
